export const homePage = {
    urlVideoException: ['https://mp4.ina.fr/'], // url exception for play video url who is not know by js-video-url-parser
    redirectUserByRole: {
        trainer: 'boussole'
    }
};
